import Cricket from "components/cricket";
import RacingGame from "components/racingGame";
import Soccer from "components/soccer";
import Tennis from "components/tennis";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

function Game() {
    const { id } = useParams();
    const { cricketEvents, soccerEvents, tennisEvents, loading, events } = useSelector((state) => state.events);
    return (
        <div className="relative w-full">
            <div className="grid grid-cols-12 px-[6px]">
                <div className='col-span-12 mb-[7px]'>
                    {
                        id == 4 && <img alt="" src="/assets/images/banner/Cricket-banner.jpg" />
                    }
                    {
                        id == 1 && <img alt="" src="/assets/images/banner/Soccer-banner.jpg" />
                    }
                    {
                        id == 2 && <img alt="" src="/assets/images/banner/Tennis-banner.jpg" />
                    }
                    {
                        id == 7 && <img alt="" src="/assets/images/banner/horseracing-banner.jpg" />
                    }
                    {
                        id == 4339 && <img alt="" src="/assets/images/banner/greyhoundracing-banner.jpg" />
                    }
                </div>
                <div className='col-span-12 '>
                    {
                        id == 4 && <Cricket events={cricketEvents && [...cricketEvents]
                            .sort((a, b) => new Date(a.open_date) - new Date(b.open_date))} />
                    }
                    {
                        id == 1 && <Soccer events={soccerEvents && [...soccerEvents]
                            .sort((a, b) => new Date(a.open_date) - new Date(b.open_date))} />
                    }
                    {
                        id == 2 && <Tennis events={tennisEvents && [...tennisEvents]
                            .sort((a, b) => new Date(a.open_date) - new Date(b.open_date))
                        } />
                    }
                    {
                        id == 7 && <RacingGame />
                    }
                    {
                        id == 4339 && <RacingGame />
                    }
                </div>
            </div>
        </div>
    );
}

export default Game;